import type { DropzoneProps } from '@mantine/dropzone';
import { Dropzone } from '@mantine/dropzone';
import React, { forwardRef } from 'react';

import styles from './DropZone.module.css';

export const LBDropZone = forwardRef<
  React.ElementRef<typeof Dropzone>,
  DropzoneProps
>(({ children, ...props }, ref) => (
  <Dropzone ref={ref} {...props} className={styles.root}>
    {children}
  </Dropzone>
));
